<div class="row justify-content-between rule-issues-table-container">
  <div aria-live="polite" role="status" class="visuallyhidden">
    {{ 'v_table_has_been_loaded' | translate: ('view_by' | translate) + ' ' + ('rule' | translate) }}
  </div>
  @if (canViewAutomatedRemediation && !isMobileScan) {
    <div class="col-12 mb-3" data-test-id="automated-remediation-info-banner">
      <ds-banner
        data-test-id="rule-issue-banner"
        [state]="DsBannerState.info"
        [showTitle]="false"
        [showAction]="false"
        [showCloseButton]="false"
      >
        <div ds-banner-body>
          <span>{{ 'issues_table_automated_remediation_info_message' | translate }}</span>
          <ds-link
            class="ms-1"
            [standalone]="false"
            [external]="true"
            href="https://client.levelaccess.com/hc/en-us/articles/31059428597143"
            >{{ 'issues_table_automated_remediation_info_message_link_label' | translate }}</ds-link
          >
        </div>
      </ds-banner>
    </div>
  }
  <div class="col rule-filter-container">
    <app-rule-filter
      [status]="issueStatusFilter"
      (onFilterChanged)="filterStatus($event)"
      [failedRulesCount]="failedRulesCount"
      [reviewRulesCount]="reviewRulesCount"
      [passedRulesCount]="passedRulesCount"
      [hidePassedRules]="hasComponentId || auditTool === AccessibilityAuditToolNames.wave"
    ></app-rule-filter>
  </div>
  <div class="col-12 col-xl-auto d-flex align-items-center mb-3">
    <div class="row">
      <div class="col-12 col-md-auto d-flex align-items-center mb-3 pe-0">
        <label for="entriesPerPage" class="me-2">
          {{ 'label_rows_per_page' | translate }}
        </label>
        <select [ngModel]="entriesPerPage" (ngModelChange)="onEntriesPerPageChange($event)" id="entriesPerPage" class="me-4">
          @for (val of entriesAmounts; track $index) {
            <option [ngValue]="val">{{ val }}</option>
          }
        </select>
      </div>
      <div class="col-12 col-md-auto d-flex align-items-center mb-3">
        <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, filteredTableData.length) }}</span>
        <ngb-pagination
          class="d-flex align-items-center"
          [attr.aria-label]="'aria_label_scan_results_issues_table_top_pagination' | translate"
          [page]="page"
          (pageChange)="onPageChange($event)"
          [pageSize]="entriesPerPage"
          [collectionSize]="filteredTableData.length"
        >
          <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
          <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
          <ng-template ngbPaginationNumber let-pageNum>
            <span class="visually-hidden">
              {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
              &nbsp;
            </span>
            {{ pageNum }}
          </ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <app-ngb-table
      data-e2e-id="report-table"
      #issuesTable
      [config]="filteredTableConfig"
      [data]="filteredPaginatedTableData()"
      (onSort)="onTableSort($event)"
    >
    </app-ngb-table>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12 d-flex justify-content-end align-items-center">
    <span class="me-3 text-black">{{ getPaginationLabel(page, entriesPerPage, filteredTableData.length) }}</span>
    <ngb-pagination
      class="d-flex align-items-center"
      [attr.aria-label]="'aria_label_scan_results_issues_table_bottom_pagination' | translate"
      [page]="page"
      (pageChange)="onPageChange($event)"
      [pageSize]="entriesPerPage"
      [collectionSize]="filteredTableData.length"
    >
      <ng-template ngbPaginationPrevious>{{ 'label_previous' | translate }}</ng-template>
      <ng-template ngbPaginationNext>{{ 'label_next' | translate }}</ng-template>
      <ng-template ngbPaginationNumber let-pageNum>
        <span class="visually-hidden">
          {{ (pageNum !== page ? 'go_to_page' : 'page') | translate }}
          &nbsp;
        </span>
        {{ pageNum }}
      </ng-template>
    </ngb-pagination>
  </div>
</div>

@if (recommendationsTable.dataLength > 0) {
  <app-rule-issues-supplementary-table
    [tableController]="recommendationsTable"
    [title]="'recommendations'"
    [description]="'best_practices_table_description'"
    [name]="'recommendations'"
    [topPaginationAriaLabel]="'aria_label_scan_results_recommendations_table_top_pagination'"
    [bottomPaginationAriaLabel]="'aria_label_scan_results_recommendations_table_bottom_pagination'"
  >
  </app-rule-issues-supplementary-table>
}

@if (showRuleIssuesSupplementartyTable) {
  <app-rule-issues-supplementary-table
    [tableController]="manualReviewTable"
    [title]="'manual_review_required'"
    [description]="'manual_review_required_description'"
    [name]="'manual_review'"
    [topPaginationAriaLabel]="'aria_label_scan_results_manual_review_table_top_pagination'"
    [bottomPaginationAriaLabel]="'aria_label_scan_results_manual_review_table_bottom_pagination'"
  >
  </app-rule-issues-supplementary-table>
}
